import { useState } from "react";

const RETRY_NOTICE = "We could not complete that sign-in. Select Sign in to try again.";

function readLoginRetryNotice(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const flag = new URLSearchParams(window.location.search).get("login");
    if (flag === "retry") {
      return RETRY_NOTICE;
    }
  } catch {
    // Ignore malformed search parameters.
  }
  return null;
}

export function SignInPage(): JSX.Element {
  const [retryNotice] = useState(readLoginRetryNotice);
  const currentYear = new Date().getFullYear();

  return (
    <main className="platform-signin">
      <section className="platform-signin__rail" aria-label="Fulcrum5 Platform">
        <header className="platform-signin__rail-header">
          <span className="platform-signin__rail-label">Fulcrum5</span>
        </header>

        <div className="platform-signin__rail-body">
          <img
            alt=""
            aria-hidden="true"
            className="platform-signin__watermark"
            height="512"
            src="/product-icons/platform.svg"
            width="512"
          />
          <div className="platform-signin__rail-copy">
            <p className="platform-signin__statement">Your Fulcrum5 suite in one place.</p>
            <p className="platform-signin__supporting">
              Manage your organization, people, and product access from one workspace.
            </p>
          </div>
        </div>

        <footer className="platform-signin__rail-footer">© {currentYear} Fulcrum5</footer>
      </section>

      <section className="platform-signin__panel" aria-labelledby="platform-signin-title">
        <header className="platform-signin__panel-header">
          <div className="platform-signin__lockup">
            <img
              alt=""
              aria-hidden="true"
              height="36"
              src="/product-icons/platform.svg"
              width="36"
            />
            <span>Fulcrum5 Platform</span>
          </div>
        </header>

        <div className="platform-signin__panel-body">
          <div className="platform-signin__auth">
            <h1 id="platform-signin-title">Sign in to Platform</h1>
            <p className="platform-signin__body-copy">
              Use your Fulcrum5 account to continue to your organization&apos;s workspace.
            </p>

            {retryNotice ? (
              <p className="platform-signin__notice" role="status">
                {retryNotice}
              </p>
            ) : null}

            <a className="platform-signin__button" href="/auth/login">
              Sign in
            </a>
            <p className="platform-signin__helper">
              Use the account connected to your organization.
            </p>
          </div>
        </div>

        <footer className="platform-signin__panel-footer">© {currentYear} Fulcrum5</footer>
      </section>
    </main>
  );
}
